import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { UploadEditedImageComponent } from 'src/app/community/upload-edited-image/upload-edited-image.component';
import { EditedImageResult } from 'src/app/community/upload-edited-image/upload-edited-image.types';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { suggestions } from '../../marketplace/view-product-details/view-product.interface';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';



@Component({
  selector: 'app-site-links',
  templateUrl: './site-links.component.html',
  styleUrl: './site-links.component.scss',
})
export class SiteLinksComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('mainContainer') mainContainer: ElementRef;

  @Output()
  filterProductByFavorite = new EventEmitter();

  carouselWithNavOptions2: any = {
    spaceBetween: 1,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
  };
  isUserLogin: any = 0;
  filterByPopular() {
    this.filterProductByFavorite.emit('');
  }

  constructor(
    private router: Router,
    private local: LocalServiceService,
    public sharedService: SharedService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet
  ) { }
  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
  }
  /////////////////////////////////////////////////////////// Code reltated to explanations /////////////////////////////////////
  public get isMobile() : boolean{
    return this.sharedService.isBrowser() && window.innerWidth <= 767
  }

  @ViewChild('explantionModal')
  public explainationModal: TemplateRef<any>;

  public explainCarouselConfig: any = {
    spaceBetween: 1,
    slidesPerView: 1,
    // loop: true,
    pagination: true,
  };
  private explainerSwiper = null
  public activeSwiper = 0
  public tutorialGoTo(index){
    this.explainerSwiper?.slideTo(index)
    this.activeSwiper = index
  }
  public tutorialBtns = [
  
      {
        goToIndex: 0,
        iconClass: "fa-solid fa-lightbulb",
        title: "Overview"
      },
      {
        goToIndex: 1,
        iconClass: "fa-solid fa-plus",
        title: "Post Product"
      },
      // {
      //   goToIndex: 2,
      //   iconClass: "fa-solid fa-thumbs-up",
      //   title: "Recommend"
      // },
      {
        goToIndex: 2,
        iconClass: "fa-solid fa-bug",
        title: "Report Bug"
      },
      {
        goToIndex: 3,
        iconClass: "fa-solid fa-pen",
        title: "Review"
      },
      {
        goToIndex: 4,
        iconClass: "fa-solid fa-map-marker-alt",
        title: "Post Moment"
      },
      {
        goToIndex: 5,
        iconClass: "fa-solid fa-gift",
        title: "Claim Rewards"
      }
    
  ]
  public onExplainerSwiper(swiper){
    this.explainerSwiper = swiper;
  }
  swiperSlider(e){
    this.activeSwiper = e.activeIndex
  }

  public showExplantion(){
    if(this.isMobile){
      this.bottomSheet.open(this.explainationModal, {panelClass: 'bottom-sheet-1'})
    }else{
      this.modalService.open(this.explainationModal)
    }

  }


  public tutorialSlides = [
    {
      title: "Earn Points & Get Rewards!",
      description: "Complete activities like posting products, recommending, reporting bugs, and more. The more you contribute, the more points you collect. Redeem your points anytime for exciting rewards!",
      // screenshot: "reward-bg.jpg",
    },
    {
      title: "Post a Product or Service",
      description: "Add a new product or service to help others discover it. Earn points for every post you create.",
      screenshot: "quickbar.png",
    },
    // {
    //   title: "Recommend a Product or Service",
    //   description: "Suggest products or services you trust. Earn points when your recommendations help others.",
    //   screenshot: "recommend.png",
    // },
    {
      title: "Report Bugs",
      description: "Find any bugs or issues? Report them easily. Get points as a thank you for making the platform better.",
      screenshot: "bug_report.png",
    },
    {
      title: "Review Products",
      description: "Write reviews about products or services you’ve tried. Earn points for every honest review you post.",
      screenshot: "cna.png",
    },
    {
      title: "Post a Moment Near You",
      description: "Capture moments around you and suggest improvements. Points are awarded for valuable contributions.",
      screenshot: "share_moment.png",
    },
    {
      title: "Claim Your Rewards",
      description: "Go to the Rewards page to claim gifts, discounts, or special perks. Enjoy the benefits of your contributions!",
      screenshot: "reward_1.png",
    },
  ];
  
  /////////////////////////////////////////////////////////// Code related to admin suggestion management will be moved to another file /////////////
  @ViewChild('adminSuggestionModal')
  public adminSuggestionModal: TemplateRef<any>
  public getAllProps(row: any) {
    const allRatingKeys = ['Rating', 'Count'].map(x => {
      return [`cat${x}`, `ggle${x}`, `fb${x}`]
    }).flat();

    const commandedRatingKeys = allRatingKeys.filter(x => row?.reviewsRatingSuggestion && row?.reviewsRatingSuggestion[x]);
    console.log({ allRatingKeys, commandedRatingKeys })

    const commandedDelVarKeys = row.flaggedVariants.map(v => 'del' + v);



    console.log({ commandedDelVarKeys })
    console.log({ row })


    return [
      ...commandedDelVarKeys,
      'DESCR',
      ...commandedRatingKeys,
      ...(['One', 'Two', 'Three', 'Four'].map(suff => 'image' + suff).filter(x => row[x])),
      ...(row.varSugs?.map(v => 'var' + v[0]) || [])
    ]
  }
  private _getAllReports(): void {
    this.auth.getAllReports().subscribe((response: ApiResponse) => {
      this.allReports = response?.body || [];
      console.log("ALL REPORTS", this.allReports);
    });
  }
  public imgUrl = environment.ImageUrl

  public allReports = []
  public adminActiveTab = 'Suggesttions'
  public appReview(reviewId, property) {
    this.local.confirmYesNo({ title: "Are you sure", text: 'Are you sure you want to apply change to product', icon: 'warning' })
      .then(
        res => {
          if (res.isConfirmed) {
            this.auth.applyReviewChange(reviewId, property).subscribe(
              {
                next: () => {
                  this.toastr.success("Change Applied to product")
                },
                error: err => {
                  console.error(err);
                  this.toastr.error("Something went wrong when applying change to product")
                }
              }
            )

          }
        }
      )




  }

  public openImage(url) {

    this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent, {
      size: "sm",
      windowClass: "image-modal",
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;

  }
  /////////////////////////////admin settings///////////////////////////
  public readonly RECOMMEND_REWARD_KEY = 'RECOMMEND_REWARD'
  public readonly SUGGESTIONS_REWARD_KEY = 'SUGGESTIONS_REWARD'
  public readonly REPORTS_REWARD_KEY = 'REPORTS_REWARD'
  public readonly PRODUCTS_POST_REWARD_KEY = 'PRODUCTS_POST_REWARD'
  public readonly ASK_POST_REWARD_KEY = 'ASK_POST_REWARD'
  public readonly REVIEW_REWARD_KEY = "REVIEW_REWARD"
  public readonly SUGGEST_REWARD_KEY = "SUGGEST_REWARD"
  public readonly MOMENTS_REWARD_KEY = 'MOMENTS_REWARD'

  public SUGGESTIONS_REWARD = 0;
  public REPORTS_REWARD = 0;
  public PRODUCTS_POST_REWARD = 0;
  public ASK_POST_REWARD = 0;
  public REVIEW_REWARD = 0;
  public SUGGEST_REWARD = 0;
  public RECOMMEND_REWARD = 0
  public MOMENTS_REWARD = 0

  
  public SUGGESTIONS_REWARD_LIMIT = 2;
  public REPORTS_REWARD_LIMIT = 2;
  public PRODUCTS_POST_REWARD_LIMIT = 2;
  public ASK_POST_REWARD_LIMIT  = 2;
  public REVIEW_REWARD_LIMIT  = 2;
  public SUGGEST_REWARD_LIMIT = 2;
  public MOMENTS_REWARD_LIMIT = 2
  public RECOMMEND_REWARD_LIMIT  = 2
 





  @ViewChild('adminSettings')
  public adminSettingsModal: TemplateRef<any>
  public adminSettings: any = {
    rewardsSetting: {}
  }
  private _getRewardPts() {
    this.auth.getAssignedPointRewards()
      .subscribe({

        next: data => {
          console.log({ data })
          this.adminSettings.rewardsSetting = {};
          for (const setting of data.body) {
            this.adminSettings.rewardsSetting[setting.action] = setting.reward;
          }
          for (const prop of [this.RECOMMEND_REWARD_KEY,this.MOMENTS_REWARD_KEY,  this.SUGGESTIONS_REWARD_KEY, this.REPORTS_REWARD_KEY, this.PRODUCTS_POST_REWARD_KEY, this.ASK_POST_REWARD_KEY, this.REPORTS_REWARD_KEY, this.REVIEW_REWARD_KEY]) {
            if (!this.adminSettings.rewardsSetting[prop]) {
              this.adminSettings.rewardsSetting[prop] = 2;
            }
          }


          this.SUGGESTIONS_REWARD = this.adminSettings.rewardsSetting[this.SUGGESTIONS_REWARD_KEY]
          this.REPORTS_REWARD = this.adminSettings.rewardsSetting[this.REPORTS_REWARD_KEY]
          this.PRODUCTS_POST_REWARD = this.adminSettings.rewardsSetting[this.PRODUCTS_POST_REWARD_KEY]
          this.ASK_POST_REWARD = this.adminSettings.rewardsSetting[this.ASK_POST_REWARD_KEY]
          this.REVIEW_REWARD = this.adminSettings.rewardsSetting[this.REVIEW_REWARD_KEY]
          this.RECOMMEND_REWARD = this.adminSettings.rewards[this.RECOMMEND_REWARD_KEY]
          this.MOMENTS_REWARD = this.adminSettings.rewards[this.MOMENTS_REWARD_KEY]
        }

      })
  }
  public openAdminSettings() {
    this.modalService.open(this.adminSettingsModal, { size: 'md' });

  }
  public closeModal() {
    this.modalService.dismissAll()
  }
  public saveAdminSettings() {
    //console.log('rewards: ',   this.adminSettings.rewardsSetting)
    //       public REPORTS_REWARD = 2;
    // public PRODUCTS_POST_REWARD = 2;
    // public ASK_POST_REWARD = 2;
    const actionRewards = [
      {
        action: this.SUGGESTIONS_REWARD_KEY,
        reward: this.SUGGESTIONS_REWARD,
        limitPerDay: this.SUGGESTIONS_REWARD_LIMIT
      },
      {
        action: this.REPORTS_REWARD_KEY,
        reward: this.REPORTS_REWARD,
        limitPerDay: this.REPORTS_REWARD_LIMIT
      }, {
        action: this.PRODUCTS_POST_REWARD_KEY,
        reward: this.PRODUCTS_POST_REWARD,
        limitPerDay: this.PRODUCTS_POST_REWARD_LIMIT
      },
      {
        action: this.MOMENTS_REWARD_KEY,
        reward: this.MOMENTS_REWARD,
        limitPerDay: this.MOMENTS_REWARD_LIMIT
      },
      {
        action: this.ASK_POST_REWARD_KEY,
        reward: this.ASK_POST_REWARD,
        limitPerDay: this.ASK_POST_REWARD_LIMIT
      },
      {
        action: this.REVIEW_REWARD_KEY,
        reward: this.REVIEW_REWARD,
        limitPerDay: this.REVIEW_REWARD_LIMIT
      },
      {
        action: this.RECOMMEND_REWARD_KEY,
        reward: this.RECOMMEND_REWARD,
        limitPerDay: this.RECOMMEND_REWARD_LIMIT
      }
    ]
    for (const { action, reward, limitPerDay } of actionRewards) {
      this.auth.setAssignedPointReward({ action, reward, limitPerDay }).subscribe({
        error: console.error, next: () => {
          this.toastr.success(`${action} changed`)
        }
      })

    }

  }
  ////////////////////////////////////////////////////////////////////
  public click(j) {
    const link = this.links[j]
    if (j == 0) {
      this.openAdminSuggestionModal();
    }
    else {
      this.openLink(link?.link, link?.name)
    }

  }
  private _suggesgionModalRef: NgbModalRef = null;
  public openAdminSuggestionModal() {
    this._suggesgionModalRef = this.modalService.open(this.adminSuggestionModal, { size: 'lg', centered: true });
    this.fetchSuggestions();
  }
  public discardReview(suggestionId) {
    this.local.confirmYesNo({ title: "Are you sure", text: 'Are you sure you want to remove review', icon: 'warning' })
      .then(
        res => {
          if (res.isConfirmed) {
            this.auth.removeReview((suggestionId)).
              subscribe({
                next: () => {
                  this.fetchSuggestions();
                  this.toastr.success("Removed");
                },
                error: err => {
                  this.toastr.error("Something went wrong while deleting :(")
                  console.error(err)
                }
              })
          }
        }
      )


  }

  public suggestions = [];
  public suggestionSearchText = '';
  public currentSuggestionPage = 1;

  public prevPage() {
    if (this.currentSuggestionPage == 1) {
      return;
    }
    this.currentSuggestionPage -= 1;
    this.fetchSuggestions();

  }
  public nextPage() {
    if (this.suggestions.length == 0) {
      return
    }

    this.currentSuggestionPage += 1;
    this.fetchSuggestions();

  }
  public closeSuggestChangeModal() {
    this._suggesgionModalRef?.close();
  }

  public fetchSuggestions() {
    this.auth.getProductReviews(this.suggestionSearchText, this.currentSuggestionPage)
      .subscribe({
        next: data => {
          this.suggestions = data.body;
          this.suggestions.forEach(
            sug => {
              try {
                const J = JSON.parse(sug.variationPriceSuggestion);
                sug.varSugs = []
                for (const K in J) {
                  sug.varSugs.push([K, J[K]])
                }

              } catch (e) {
                console.error(e)
              }



              try {
                const J = JSON.parse(sug.likedVariants);
                sug.likedVariants = J

              } catch (e) {
                console.error(e)
              }

              try {
                const J = JSON.parse(sug.flaggedVariants);
                sug.flaggedVariants = J


              } catch (e) {
                console.error(e)
              }

              try {
                const J = JSON.parse(sug.reviewsRatingSuggestion)
                sug.reviewsRatingSuggestion = J
                console.log({ J })
              } catch (e) {
                console.error(e)
              }

            },
          )
        },
        error: err => {
          console.error(err);
          this.toastr.error("Something went wrong please try again latter")
        }
      })

  }
  public suggestionMap = suggestions;


  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  private referralCode = '';
  private _roleSubscription: Subscription = null;
  public isAdmin = false;
  ngOnInit(): void {
    this._getAllReports();
    this._getRewardPts();

    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN');
      this.cdr.detectChanges()
    })



    this.local.getUserDetailsObserver().subscribe((user) => {
      if (!this.sharedService.isBrowser()) {
        return;
      }
      this.referralCode = this.local.getUser()?.referralCode;
      if (user?.id) {
        this.isUserLogin = 1;
        this.links = [...this.links]
        this.cdr.detectChanges()
      } else {
        this.isUserLogin = 0;
      }
    });
  }
  ngAfterViewInit(): void {
    // if(window.innerWidth <= 767){
    //   const scrollAmount = (document.documentElement.scrollWidth * 37.5) / 100;
    //   this.mainContainer?.nativeElement?.scroll(scrollAmount, 0)
    // }
  }


  ///////////////////////////////////////////////////////////////////////////////////////////
  public subregionImageUploadId = 'subregion-upload-image'
  public subregionImageUploadIdCamera = 'subregion-upload-image-camera'
  public selectedRegionImageToUpload: File | null = null
  public selectedRegionImageToUploadBuffer = null

  public subregionImageUploadChanged(event) {
    const { target } = event;
    const file = target.files[0];

    this.selectedRegionImageToUpload = file

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.selectedRegionImageToUploadBuffer = fileReader.result;
    }
    fileReader.readAsDataURL(this.selectedRegionImageToUpload)

  }
  private getActiveSubregionId() {
    let subRegionId = this.local.getUser()?.region;


    return subRegionId
  }
  public subregionImageUploadCurrentCaption = '';
  public submitSubregionFileUpload() {
    if (!this.selectedRegionImageToUpload) {
      this.toastr.info("Please select an image first")
      return;
    }
    const uploadData = new FormData();
    uploadData.append('subregionId', this.getActiveSubregionId())
    uploadData.append('image', this.selectedRegionImageToUpload);
    uploadData.append('caption', this.subregionImageUploadCurrentCaption);

    this.auth.uploadSubregionImage(uploadData)
      .subscribe({
        next: () => {
          this.toastr.success("Uploaded!")
          this.selectedRegionImageToUpload = null;
          this.selectedRegionImageToUploadBuffer = null;
          this.subregionImageUploadCurrentCaption = '';
          this.modalService.dismissAll();
          this._getSubRegionImages()
        },

        error: err => {
          this.toastr.error("Error something went wrong!");
          console.error(err)
        }
      })
  }



  public currentCropInformationToBeSaved = null;



  public openUploadSubregionImageModal() {
    const modalRef = this.modalService.open(UploadEditedImageComponent, { size: 'sm', centered: true });
    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }

    modalRef.componentInstance.topText = topText;
    modalRef.result.then(
      (res: EditedImageResult) => {
        this.currentCropInformationToBeSaved = res.cropInformation;
        this.selectedRegionImageToUpload = res.imageData as File;
        this.subregionImageUploadCurrentCaption = res.caption;
        this.submitSubregionFileUpload();
      }
    )

  }
  public subregionUploadedImage = []
  public showImagePopup(url, text = '') {

    this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent, {
      size: "sm",
      windowClass: "image-modal",
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;
    instance.componentInstance.descr = text;

  }
  public imageUrl = environment.ImageUrl;

  private _getSubRegionImages() {
    this.auth.getSubRegionUploadedImages(this.getActiveSubregionId())
      .subscribe(
        {
          next: data => {
            this.subregionUploadedImage = data.body;

          },
          error: err => {
            console.error(err);
          }
        }
      )
  }

  public toggleUploadRxn(uploadedImage, type) {
    this.auth.toggleUploadReaction(uploadedImage.id, type).subscribe(
      {
        next: () => {
          this._getSubRegionImages();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error something went wrong while reacting")
        }
      }
    )

  }

  ////////////////////////////////////////////////////////////////////////////////////////

  public clickLogin() {
    this.modalService.dismissAll();
    this.commonService.clickButton('loginBtn');
  }
  public loginWhy = '';
  @ViewChild('whyLogin') public whyLogin: TemplateRef<any>;
  public openLink(link, name) {
    const isUserLoggedIn = this.local.getUser();
    if (!isUserLoggedIn && ['Nearby', 'Favourites', 'Report Bug', 'Share Moment', 'Services'].includes(name)) {
      this.loginWhy = name?.toLowerCase();

      this.modalService.open(this.whyLogin, { size: 'sm', centered: true, modalDialogClass: 'w-50', windowClass: 'd-flex justify-content-center' })
      return;
    }
    if(name == 'Contribute'){
      this.showExplantion();
      return;
    }
    if (name == 'Share Moment') {
      this.openUploadSubregionImageModal();
      return;
    }
    if (name == 'Report Bug') {
      this.local.alertReport()
        .then((result) => {
          if (result.isConfirmed && result.value) {
            const report = result.value;

            const data = new FormData();
            data.append('message', report.reportDetails);
            data.append('type', report.reportType)
            data.append('category', 'member');
            data.append('image', report.file);
            this.auth
              .submitReportMessage(data)
              .subscribe(
                () => {
                  this.toastr.success('Reported successfully');
                },
                (e) => {
                  this.toastr.error(e.error.message);
                }
              );
          }
        });;
      return
    }

    if (name == 'Favourites') {
      link = link + this.local?.getUser()?.referralCode
    }
    this.router.navigateByUrl(link);
  }
  public links: any = [
    {
      name: 'Site Settings',
      image: 'gear.png'
    },
    // {
    //     name: 'Suggestions',
    //     image: 'attach-file.png'
    // },
    {
      name: 'Contribute',
      image: 'w.jpeg'
    },
    {
      name: 'Services',
      image: 'search_2.png',
      link: '/me/nearby',
    },
    {
      name: 'Giveaway',
      image: 'gift_2.png',
      link: '/giveaway',
      // glow: true,
    },
    {
      name: 'Share Moment',
      image: 'near-me-upload.webp',
      link: '-'
    },
    {
      name: 'Report Bug',
      image: 'bug.webp',
      link: null,
    },
    {
      name: 'Join us',
      image: 'join.png',
      link: '/biz/join',
    },
    {
      name: 'Favourites',
      image: 'love.png',
      link: '/profile/'
    },
    {
      name: 'News',
      image: 'news.png',
      link: '/news',
    },
    {
      name: 'FAQ',
      image: 'faq.png',
      link: '/faq',
    },
  ];
}
